import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { StateContext } from '../../../../../../StateProvider';
import './ReceptionRetail.css';

import eventIcon from '../../../../../../../assets/Console/Landing/eventIcon.png';
import petIcon from '../../../../../../../assets/Console/Landing/petIcon.png';
import incidentIcon from '../../../../../../../assets/Console/Landing/incidentIcon.png';
import arrowIcon from '../../../../../../../assets/Landing/arrowIcon.png';

function ReceptionRetail() {
  var ctx = useContext(StateContext) || {};
  var navigate = useNavigate();

  // Optional incoming data from context
  var incomingProducts = ctx.retailProducts;
  var incomingTaxRate = ctx.taxRate;

  // Demo catalog if context not hydrated
  var demoProducts = [
    { id: 'SKU-1001', name: 'Pawsible Daily Kibble 5 lb', category: 'Food', price: 26.00, memberPrice: 22.00, stock: 14, lowAt: 10 },
    { id: 'SKU-1002', name: 'Freeze Dried Chicken Treats', category: 'Treats', price: 12.00, memberPrice: 10.00, stock: 6, lowAt: 8 },
    { id: 'SKU-1003', name: 'Biodegradable Poop Bags 8 Rolls', category: 'Essentials', price: 8.00, memberPrice: 7.00, stock: 48, lowAt: 12 },
    { id: 'SKU-1004', name: 'Soft Harness XS', category: 'Accessories', price: 28.00, memberPrice: 24.00, stock: 3, lowAt: 5 },
    { id: 'SKU-1005', name: 'Gentle Shampoo 16 oz', category: 'Grooming', price: 18.00, memberPrice: 15.50, stock: 25, lowAt: 6 },
    { id: 'SKU-1006', name: 'Dental Chew Sticks 10 ct', category: 'Health', price: 14.00, memberPrice: 12.00, stock: 9, lowAt: 10 },
    { id: 'SKU-1007', name: 'Catnip Plush Mouse', category: 'Cat', price: 7.00, memberPrice: 6.00, stock: 20, lowAt: 8 },
    { id: 'SKU-1008', name: 'Slicker Brush Small', category: 'Grooming', price: 16.00, memberPrice: 14.00, stock: 11, lowAt: 5 }
  ];

  var initialProducts = Array.isArray(incomingProducts) && incomingProducts.length > 0 ? incomingProducts : demoProducts;

  // State
  var _useState1 = useState(initialProducts), products = _useState1[0], setProducts = _useState1[1];
  var _useState2 = useState('All'), category = _useState2[0], setCategory = _useState2[1];
  var _useState3 = useState(''), search = _useState3[0], setSearch = _useState3[1];
  var _useState4 = useState([]), cart = _useState4[0], setCart = _useState4[1];
  var _useState5 = useState(false), member = _useState5[0], setMember = _useState5[1];
  var _useState6 = useState(0), discountPct = _useState6[0], setDiscountPct = _useState6[1]; // percent off
  var _useState7 = useState(0), discountAmt = _useState7[0], setDiscountAmt = _useState7[1]; // fixed
  var _useState8 = useState(typeof incomingTaxRate === 'number' ? incomingTaxRate : 9.5), taxRate = _useState8[0], setTaxRate = _useState8[1];
  var _useState9 = useState(null), heldCart = _useState9[0], setHeldCart = _useState9[1];
  var _useState10 = useState(''), customerRef = _useState10[0], setCustomerRef = _useState10[1]; // phone or member id

  // Sync from context when it updates
  useEffect(function () {
    if (Array.isArray(incomingProducts) && incomingProducts.length > 0) {
      setProducts(incomingProducts);
    }
    if (typeof incomingTaxRate === 'number') {
      setTaxRate(incomingTaxRate);
    }
  }, [incomingProducts, incomingTaxRate]);

  // Derived categories
  var categories = useMemo(function () {
    var seen = { All: true };
    var out = ['All'];
    var i = 0;
    while (i < products.length) {
      var c = products[i].category || 'Other';
      if (!seen[c]) {
        seen[c] = true;
        out.push(c);
      }
      i = i + 1;
    }
    return out;
  }, [products]);

  // Filtered product list
  function visibleProducts() {
    var out = [];
    var i = 0;
    while (i < products.length) {
      var p = products[i];
      var keepByCat = category === 'All' || p.category === category;
      var keepBySearch = true;
      if (search && search.trim().length > 0) {
        var s = search.toLowerCase();
        var blob = (p.id + ' ' + p.name + ' ' + p.category).toLowerCase();
        keepBySearch = blob.indexOf(s) >= 0;
      }
      if (keepByCat && keepBySearch) out.push(p);
      i = i + 1;
    }
    return out;
  }

  // Cart helpers
  function addToCart(productId) {
    var p = findProduct(productId);
    if (!p) return;
    setCart(function (prev) {
      var found = false;
      var next = [];
      var i = 0;
      while (i < prev.length) {
        var line = prev[i];
        if (line.id === productId) {
          found = true;
          next.push(Object.assign({}, line, { qty: line.qty + 1 }));
        } else {
          next.push(line);
        }
        i = i + 1;
      }
      if (!found) next.push({ id: p.id, name: p.name, price: p.price, memberPrice: p.memberPrice, qty: 1 });
      return next;
    });
  }

  function decQty(productId) {
    setCart(function (prev) {
      var next = [];
      var i = 0;
      while (i < prev.length) {
        var line = prev[i];
        if (line.id === productId) {
          var q = line.qty - 1;
          if (q > 0) next.push(Object.assign({}, line, { qty: q }));
          // omit if zero
        } else {
          next.push(line);
        }
        i = i + 1;
      }
      return next;
    });
  }

  function removeLine(productId) {
    setCart(function (prev) {
      var next = [];
      var i = 0;
      while (i < prev.length) {
        if (prev[i].id !== productId) next.push(prev[i]);
        i = i + 1;
      }
      return next;
    });
  }

  function clearCart() {
    setCart([]);
  }

  function holdCart() {
    setHeldCart(cart);
    setCart([]);
  }

  function resumeHeld() {
    if (heldCart && heldCart.length > 0) {
      setCart(heldCart);
      setHeldCart(null);
    }
  }

  function findProduct(id) {
    var i = 0;
    while (i < products.length) {
      if (products[i].id === id) return products[i];
      i = i + 1;
    }
    return null;
  }

  // Totals
  var totals = useMemo(function () {
    var sub = 0;
    var items = 0;
    var i = 0;
    while (i < cart.length) {
      var line = cart[i];
      var unit = member && typeof line.memberPrice === 'number' ? line.memberPrice : line.price;
      sub = sub + unit * line.qty;
      items = items + line.qty;
      i = i + 1;
    }
    var pctOff = (discountPct > 0 ? sub * (discountPct / 100) : 0);
    var amtOff = discountAmt > 0 ? discountAmt : 0;
    var disc = Math.min(sub, pctOff + amtOff);
    var net = Math.max(0, sub - disc);
    var tax = net * (taxRate / 100);
    var grand = net + tax;
    return { items: items, sub: sub, disc: disc, net: net, tax: tax, total: grand };
  }, [cart, member, discountPct, discountAmt, taxRate]);

  // KPIs
  var kpis = useMemo(function () {
    var revenueToday = ctx.retailSummary && typeof ctx.retailSummary.revenueToday === 'number' ? ctx.retailSummary.revenueToday : 680;
    var itemsSold = ctx.retailSummary && typeof ctx.retailSummary.itemsSold === 'number' ? ctx.retailSummary.itemsSold : 42;
    var aov = itemsSold > 0 ? revenueToday / Math.ceil(itemsSold / 2) : revenueToday; // rough placeholder
    return { revenueToday: revenueToday, itemsSold: itemsSold, aov: aov.toFixed(2) };
  }, [ctx.retailSummary]);

  function formatMoney(n) {
    if (typeof n !== 'number' || isNaN(n)) return '$0.00';
    try { return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' }); }
    catch (e) { return '$' + Number(n).toFixed(2); }
  }

  // Render helpers that avoid chained map calls
  function renderCategoryOptions() {
    var els = [];
    var i = 0;
    while (i < categories.length) {
      var c = categories[i];
      els.push(<option key={c} value={c}>{c}</option>);
      i = i + 1;
    }
    return els;
  }

  function renderProducts(list) {
    var els = [];
    var i = 0;
    while (i < list.length) {
      var p = list[i];
      var low = typeof p.lowAt === 'number' && typeof p.stock === 'number' && p.stock <= p.lowAt;
      els.push(
        <div key={p.id} className="retail-product">
          <div className="rp-title">{p.name}</div>
          <div className="rp-meta">
            <span className="pill">{p.category || 'Other'}</span>
            {low && <span className="pill warn">Low</span>}
          </div>
          <div className="rp-price-row">
            <div className="rp-price">{formatMoney(p.price)}</div>
            {typeof p.memberPrice === 'number' && <div className="rp-member">Member {formatMoney(p.memberPrice)}</div>}
          </div>
          <div className="rp-stock">Stock {typeof p.stock === 'number' ? p.stock : '—'}</div>
          <div className="rp-actions">
            <button className="btn" onClick={function () { addToCart(p.id); }}>Add</button>
            <button className="btn ghost" onClick={function () { navigate('/console/retail/' + p.id); }}>Details</button>
          </div>
        </div>
      );
      i = i + 1;
    }
    return els;
  }

  function renderCartLines() {
    var els = [];
    var i = 0;
    while (i < cart.length) {
      var line = cart[i];
      var unit = member && typeof line.memberPrice === 'number' ? line.memberPrice : line.price;
      els.push(
        <div key={line.id} className="cart-line">
          <div className="cart-line-main">
            <div className="cart-line-title">{line.name}</div>
            <div className="cart-line-sub">{formatMoney(unit)} each</div>
          </div>
          <div className="cart-line-controls">
            <button className="btn ghost" onClick={function () { decQty(line.id); }}>−</button>
            <div className="qty">{line.qty}</div>
            <button className="btn ghost" onClick={function () { addToCart(line.id); }}>+</button>
          </div>
          <div className="cart-line-total">{formatMoney(unit * line.qty)}</div>
          <button className="btn linkish remove" onClick={function () { removeLine(line.id); }}>Remove</button>
        </div>
      );
      i = i + 1;
    }
    if (els.length === 0) {
      els.push(
        <div key="empty" className="cart-empty">
          <img src={incidentIcon} alt="empty" />
          <p>No items yet. Add products to start a sale.</p>
        </div>
      );
    }
    return els;
  }

  // Simulate checkout hooks
  function checkout(method) {
    if (cart.length === 0) return;
    // Replace with API: POST /pos/checkout
    // payload: { cart, customerRef, member, discountPct, discountAmt, taxRate, method }
    clearCart();
    alert('Payment captured via ' + method + '. Receipt queued.');
  }

  var list = visibleProducts();

  return (
    <div className="reception-dashboard-container">
      <h4 className="console-header">Reception • Retail</h4>
      <h4 className="console-message">Quick checkouts, smart discounts, happy shelves.</h4>

      {/* KPI Strip */}
      <div className="staff-section-wrapper">
        <div className="staff-section-title">
          <span>🛍️</span> Retail Brief
        </div>
        <div className="staff-section-grid">
          <div className="brief-card">Revenue Today <strong>{formatMoney(kpis.revenueToday)}</strong></div>
          <div className="brief-card">Items Sold <strong>{kpis.itemsSold}</strong></div>
          <div className="brief-card">Avg Order <strong>{formatMoney(Number(kpis.aov))}</strong></div>
        </div>
      </div>

      {/* Filters */}
      <div className="retail-filters">
        <div className="filter-row">
          <div className="filter-item">
            <label>Category</label>
            <select value={category} onChange={function (e) { setCategory(e.target.value); }}>
              {renderCategoryOptions()}
            </select>
          </div>
          <div className="filter-item grow">
            <label>Search</label>
            <input
              value={search}
              placeholder="Scan or search by name or SKU"
              onChange={function (e) { setSearch(e.target.value); }}
            />
          </div>
          <div className="filter-item">
            <label>Customer</label>
            <input
              value={customerRef}
              placeholder="Phone or Member ID"
              onChange={function (e) { setCustomerRef(e.target.value); }}
            />
          </div>
          <div className="filter-item">
            <label>Member Pricing</label>
            <select value={member ? 'Yes' : 'No'} onChange={function (e) { setMember(e.target.value === 'Yes'); }}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
          </div>
        </div>
      </div>

      {/* Layout: products left, cart right */}
      <div className="retail-grid">
        <div className="retail-products">
          {renderProducts(list)}
        </div>

        <div className="retail-cart">
          <div className="cart-header">
            <img src={petIcon} alt="cart" />
            <div className="cart-title">Cart</div>
            <div className="cart-count">{totals.items} items</div>
          </div>

          <div className="cart-lines">
            {renderCartLines()}
          </div>

          <div className="cart-adjust">
            <div className="adjust-row">
              <div className="adjust-item">
                <label>Discount %</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  value={discountPct}
                  onChange={function (e) { setDiscountPct(Number(e.target.value) || 0); }}
                />
              </div>
              <div className="adjust-item">
                <label>Discount $</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={discountAmt}
                  onChange={function (e) { setDiscountAmt(Number(e.target.value) || 0); }}
                />
              </div>
              <div className="adjust-item">
                <label>Tax %</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={taxRate}
                  onChange={function (e) { setTaxRate(Number(e.target.value) || 0); }}
                />
              </div>
            </div>
          </div>

          <div className="cart-totals">
            <div className="row"><span>Subtotal</span><strong>{formatMoney(totals.sub)}</strong></div>
            <div className="row"><span>Discount</span><strong>−{formatMoney(totals.disc)}</strong></div>
            <div className="row"><span>Tax</span><strong>{formatMoney(totals.tax)}</strong></div>
            <div className="row grand"><span>Total</span><strong>{formatMoney(totals.total)}</strong></div>
          </div>

          <div className="cart-actions">
            <button className="btn ghost" onClick={holdCart} disabled={cart.length === 0}>Hold</button>
            <button className="btn ghost" onClick={resumeHeld} disabled={!heldCart || heldCart.length === 0}>Resume</button>
            <button className="btn linkish" onClick={clearCart} disabled={cart.length === 0}>Clear</button>

            <button className="btn" onClick={function () { checkout('Card'); }} disabled={cart.length === 0}>Pay Card</button>
            <button className="btn success" onClick={function () { checkout('Cash'); }} disabled={cart.length === 0}>Pay Cash</button>
            <button className="btn" onClick={function () { checkout('Gift'); }} disabled={cart.length === 0}>Gift Card</button>
          </div>

          <div className="cart-footnote">
            <img src={eventIcon} alt="note" />
            <p>After payment we can email or text the receipt. Refunds and exchanges live under Retail History.</p>
          </div>
        </div>
      </div>

      {/* Impact / CTA reuse */}
      <div className="container">
        <Link to="/store/deals/impact" className="impact-highlight">
          <div className="impact-highlight-card">
            <div className="impact-highlight-card-items">
              <h3 className="impact-highlight-number">Retail</h3>
              <h3 className="impact-highlight-paragraph">
                Move with taste. Offer what you would buy for your own pets.
              </h3>
              <div className="impact-highlight-action">
                <h3 className="impact-highlight-button-title">SEE OUR IMPACT</h3>
                <img src={arrowIcon} className="impact-highlight-button" alt="see impact" />
              </div>
            </div>
            <div className="impact-highlight-card-items">
              <img className="impact-highlight-icon" src={incidentIcon} alt="retail icon" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default ReceptionRetail;
